import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-workflow-search-modal',
    templateUrl: './workflow-search-modal.component.html',
    styleUrls: ['./workflow-search-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WorkflowSearchModalComponent implements OnInit {

  onSearch: EventEmitter<string> = new EventEmitter();
  
  searchQuery: UntypedFormControl = new UntypedFormControl('', [Validators.required]);

  constructor(public modalRef: BsModalRef) { }

  ngOnInit(): void {
    // Focus on the input when modal opens
    setTimeout(() => {
      const inputElement = document.querySelector('.search-input-modal') as HTMLInputElement;
      if (inputElement) {
        inputElement.focus();
      }
    }, 0);
  }

  close() {
    this.modalRef.hide();
  }

  performSearch() {
    if (this.searchQuery.valid) {
      const query = this.searchQuery.value?.trim();
      if (query) {
        this.onSearch.emit(query);
        this.modalRef.hide();
      }
    }
  }
}

